export default {
	props: ['info'],
	data() {
		return {
			isLoading: 0
		};
	},
	computed: {
		campaign() {
			return this.info?.campaign;
		}
	},
	watch: {
	},
	mounted() {
		if (__DEBUG__)
			window.campaignStations = this;

		if (!this.campaign.Stations) {
			this.$set(this.campaign, 'Stations', []);
			this.loadStations();
		}
	},
	methods: {
		removeStation(stationId) {
			this.$confirmMessage({
				title: () => this.$tCaption('Confirm action', '@actions'),
				text: this.$tCaption('Are you sure you want to remove the station from the proposal?'),
				handler: () => {
					this.campaign.Stations.splice(this.campaign.Stations.findIndex(f => f.Oid === stationId), 1);
					this.$Data.postExternalApi('Campaign/LinkUnlinkStations', {
						TargetObjectId: this.campaign.Oid,
						RelatedObjectIds: [stationId],
						IsLinkAction: false
					}).then(r => {
						this.$notifySuccess(this.$tCaption('The station has been removed from the proposal'));
					}).finally(() => {
						if (this._isDestroyed) return;
					});
				}
			});
		},
		loadStations() {
			if (!this.campaign.Stations)
				this.$set(this.campaign, 'Stations', []);
			this.isLoading++;
			this.$Data.getExternalApi('Campaign/GetCampaignStations', `campaignId=${this.campaign.Oid}`, 999).then(async r => {
				if (r?.Results?.length) {
					this.isLoading++;
					const stations = await this.$Data.getExternalApi('Station/GetStationsByIds', `stationIds=${r.Results.map(f => f.Oid)}`).finally(() => this.isLoading--);
					this.$set(this.campaign, 'Stations', stations);
				}
			}).finally(() => this.isLoading--);
		},
		async addStationsByNames(names) {
			if (__DEBUG__)
				console.debug('AddStationsByNames', { names });

			if (!names?.length) return;
			const notFoundStations = [];
			const addedStations = (await Promise.all(names?.map(f => {
				let name = f.replace(/[\ FM,\ AM,\ LP]/g, '').trim();

				return this.$Data.getExternalApi('Station/GetStations',`searchByName=${name}`, 1).then(r => {
					if (r?.Results?.length) {
						const station = r.Results[0];
						if (!this.campaign.Stations.find(f => f.Oid === station.Oid)) {
							this.campaign.Stations.push(station);
							return station;
						}							
					} else {
						notFoundStations.push(f);
					}
					return null;
				});
			}))).filter(f => f);

			if (notFoundStations.length) {
				this.$notifyWarning(this.$tCaption(`We couldn\'t find those stations: ${notFoundStations.join(', ')}`));
			}

			if (__DEBUG__)
				console.debug('addStationsByNames', { addedStations, notFoundStations });

			if (addedStations.filter(f => f).length) {
				this.$Data.postExternalApi('Campaign/LinkUnlinkStations', {
					TargetObjectId: this.campaign.Oid,
					RelatedObjectIds: addedStations.filter(f => f).map(f => f.Oid),
					IsLinkAction: true
				})
			}
		},
		addStations(stations) {
			if (stations?.length) {
				const linkStations = stations.filter(f => !this.campaign.Stations.find(s => s.Oid === f.Oid));
				if (linkStations.length) {
					this.campaign.Stations.push(...linkStations);
					this.$notifySuccess(this.$tCaption('Station(s) has been linked'));
					return this.$Data.postExternalApi('Campaign/LinkUnlinkStations', {
						TargetObjectId: this.campaign.Oid,
						RelatedObjectIds: stations.map(f => f.Oid),
						IsLinkAction: true
					});
				}
			}
		}
	}
}